(function () {
  if (window.ProductImmersiveHeroRuntimeLoaded) return;
  window.ProductImmersiveHeroRuntimeLoaded = true;

  function formatMoney(cents, format) {
    if (window.theme && window.theme.utils && typeof window.theme.utils.formatMoney === 'function') {
      return window.theme.utils.formatMoney(cents, format);
    }

    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function initialize(root) {
    if (!root || root.dataset.iphInitialized === 'true') return;
    root.dataset.iphInitialized = 'true';

    var variantsScript = root.querySelector('[data-iph-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]');
    } catch (error) {
      console.error('Unable to read immersive product variants.', error);
    }

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-iph-option-position]'));
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-iph-option-input]'));
    var variantInput = root.querySelector('[data-iph-variant-id]');
    var price = root.querySelector('[data-iph-price]');
    var compare = root.querySelector('[data-iph-compare]');
    var buyButton = root.querySelector('[data-iph-buy]');
    var buyLabel = root.querySelector('[data-iph-buy-label]');
    var image = root.querySelector('[data-iph-image]');
    var mobileSource = root.querySelector('.iph__media source');
    var quantity = root.querySelector('[data-iph-quantity]');
    var quantityMinus = root.querySelector('[data-iph-quantity-minus]');
    var quantityPlus = root.querySelector('[data-iph-quantity-plus]');
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var availableLabel = root.dataset.buttonLabel || 'Add to Cart';
    var soldOutLabel = root.dataset.soldOutLabel || 'Sold Out';

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('[data-iph-option-input]:checked');
        return selected ? selected.value : '';
      });
    }

    function exactVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function setInputsFromVariant(variant) {
      if (!variant) return;
      optionGroups.forEach(function (group, index) {
        var desiredValue = variant.options[index];
        var input = Array.prototype.slice.call(group.querySelectorAll('[data-iph-option-input]')).find(function (item) {
          return item.value === desiredValue;
        });
        if (input) input.checked = true;
      });
    }

    function resolveVariant(changedInput) {
      var options = selectedOptions();
      var variant = exactVariant(options);
      if (variant || !changedInput) return variant;

      var group = changedInput.closest('[data-iph-option-position]');
      var position = group ? Number(group.dataset.iphOptionPosition) - 1 : -1;
      variant = variants.find(function (item) {
        return position >= 0 && item.options[position] === changedInput.value;
      });
      if (variant) setInputsFromVariant(variant);
      return variant;
    }

    function updateOptionLabels() {
      optionGroups.forEach(function (group) {
        var selected = group.querySelector('[data-iph-option-input]:checked');
        var value = group.querySelector('[data-iph-option-value]');
        if (selected && value) value.textContent = selected.value;
      });
    }

    function updateVariant(variant, updateUrl) {
      updateOptionLabels();

      if (variantInput) {
        variantInput.value = variant ? variant.id : '';
        variantInput.disabled = !variant;
      }

      if (price) price.textContent = variant ? formatMoney(variant.price, moneyFormat) : '';

      if (compare) {
        var showCompare = Boolean(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
        compare.hidden = !showCompare;
        if (showCompare) compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      }

      if (buyButton && buyLabel) {
        var canBuy = Boolean(variant && variant.available);
        buyButton.disabled = !canBuy;
        buyButton.setAttribute('aria-disabled', canBuy ? 'false' : 'true');
        buyLabel.textContent = variant ? (canBuy ? availableLabel : soldOutLabel) : 'Unavailable';
      }

      if (variant && root.dataset.usesProductImage === 'true' && variant.featured_image && variant.featured_image.src) {
        if (image) {
          image.src = imageUrl(variant.featured_image.src, 3600);
          image.alt = variant.featured_image.alt || '';
        }
        if (mobileSource) mobileSource.srcset = imageUrl(variant.featured_image.src, 1500);
      }

      if (updateUrl && variant && window.history && window.history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateVariant(resolveVariant(input), true);
      });
    });

    function changeQuantity(direction) {
      if (!quantity) return;
      var min = Number(quantity.min) || 1;
      var step = Number(quantity.step) || 1;
      var current = Number(quantity.value) || min;
      quantity.value = String(Math.max(min, current + direction * step));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (quantityMinus) quantityMinus.addEventListener('click', function () { changeQuantity(-1); });
    if (quantityPlus) quantityPlus.addEventListener('click', function () { changeQuantity(1); });

    updateVariant(resolveVariant(), false);
  }

  function initializeAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-iph-root]')).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
